var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-with-icon",style:({ backgroundColor: _vm.colorComputed })},[_c('va-icon',{attrs:{"name":_vm.iconClass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }